import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export const router = Vue.router = new Router({
  mode: 'history',

  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },

  routes: [{
    path: '/',
    name: 'stats',
    meta: {auth: true},
    component: require('@comp/PageStats').default
  }, {
    path: '/login',
    name: 'login',
    meta: {auth: false},
    component: require('@comp/PageLogin').default
  }, {
    path: '/challenges',
    name: 'challenge_list',
    meta: {auth: true},
    component: require('@comp/PageChallenges').default
  }, {
    path: '/challenges-add',
    name: 'challenge_add',
    meta: {auth: true},
    component: require('@comp/PageChallengeAdd').default
  }, {
    path: '/challenges/:id',
    name: 'challenge_edit',
    meta: {auth: true},
    props: true,
    component: require('@comp/PageChallengeEdit').default
  }, {
    path: '/jobs',
    name: 'job_list',
    meta: { auth: true },
    component: require('@comp/PageJobs').default
  }, {
    path: '/jobs-add',
    name: 'job_add',
    meta: { auth: true },
    component: require('@comp/PageJobAdd').default
  }, {
    path: '/jobs/:id',
    name: 'job_edit',
    meta: { auth: true },
    props: true,
    component: require('@comp/PageJobEdit').default
  }, {
    path: '*',
    redirect: {
      name: 'login'
    }
  }]
})



// WEBPACK FOOTER //
// ./src/config/router.js